import { api } from './client';
import type { StoreSettings, StoreSettingsUpdate } from '../types';

export const settingsApi = {
  get: (storeId: number) =>
    api.get<StoreSettings>(`/settings/${storeId}`).then((r) => r.data),

  update: (storeId: number, body: StoreSettingsUpdate) =>
    api.put<StoreSettings>(`/settings/${storeId}`, body).then((r) => r.data),
};
